import styled from "styled-components";

import List from "components/templates/projects/List";
import COLORS from "components/atoms/colors";
import { H2 } from "components/atoms/text";
import ModalGuideVideo from "components/templates/projects/ModalGuideVideo";
import SHADOWS from "components/atoms/shadows";
import Modal from "components/organisms/Modal";

import useUserMe from "apis/queries/useUserMe";
import useCompanyMe from "apis/queries/useCompanyMe";

//
import useCheckMobile from "hooks/useCheckMobile";
import Guide from "./Guide";

import { Navigate, Outlet ,useNavigate } from "react-router-dom";

import { useSetRecoilState } from "recoil";
import authAtom from "stores/auth";

// 프로젝트 목록 페이지
const Projects = () => {
  const userMe = useUserMe();
  const companyMe = useCompanyMe();

  const me = companyMe || userMe;

  //
  const isMobile = useCheckMobile();

  const setAuth = useSetRecoilState(authAtom);

  if (isMobile== true) {//isMobile== true
    localStorage.removeItem("TOKEN");
    setAuth({ isLogin: false, type: "" });
    return (<><Navigate to="/Guide" /></>);
  } else {
    return (
      <>
        <Container className="pt-15 pb-10">
          <H2>My Project</H2>
        </Container>
        <Line />
        <Container className="pt-10 pb-50">
          <List />
        </Container>
        {me && (
          <Modal
            activator={(onOpen) => <BtnGuide onClick={onOpen}>?</BtnGuide>}
            modal={(onClose) => <ModalGuideVideo onClose={onClose} />}
            isActive={!me.isClosed}
            disableClickBack
          />
        )}
      </>
    );
  }
};

const Container = styled.div`
  width: 1340px;
  margin: 0 auto;
`;

const Line = styled.span`
  display: block;
  width: 100%;
  height: 1px;
  background: ${COLORS.black["20%"]};
`;

const BtnGuide = styled.button`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 76px;
  height: 76px;
  background-color: ${COLORS.primary.active};
  border-radius: 100%;
  box-shadow: ${SHADOWS.button};

  color: #fff;
  font-weight: 700;
  font-size: 34px;
`;

export default Projects;
